import {
  FormControlLabel,
  Grid,
  MenuItem,
  styled,
  Select,
  Switch,
} from '@mui/material';
import { memo } from 'react';
import DiscountTable from './DiscountTable';
import { NumericFormat } from 'react-number-format';
import DiscountPanel from './DiscountPanel';
import { Trans, useTranslation } from 'react-i18next';

import REPAIR_TYPE from 'shared/repairTypeList';
import ImagesSwiper from 'components/ImagesSwiper';
import EditableNumberField from 'components/ui/editable-fields/EditableNumberField';
import SimpleNumberField from 'components/ui/simple-fields/numeric-format/SimpleNumberField';
import CurrencyFormat from 'components/ui/text-formats/CurrencyFormat';

export default memo(function OldDesign({
  homesData,
  selectedDiscount,
  priceForSquare,
  terassaPriceForSquare,
  handleChangePriceSquare,
  handleChangeTerassaPriceSquare,
  currency,
  sellPrice,
  handleChangeSellPrice,
  isrepaired,
  handleChange,
  discount,
  discountPercentage,
  homeData,
  startPriceTopOrder,
  handleChangeStartPriceOrder,
  startPricePercentage,
  handleChangeStartPricePercent,
  handleChangePriceForMonth,
  startPrice,
  handleChangeStartPrice,
  month,
  handleChangeMonth,
  setApplyDiscount,
  applyDiscount,
  formik,
  fullPrice,
  handleChangeDiscount,
  handleChangeDiscountPercentage,
  priceForMonth,
  isEnableCalc,
  setIsEnableCalc,
  percent,
  setPercent,
  calculations,
  subsidyCals,
  splitCals,
  secondaryPercent,
  setSecondaryPercentOverride,
  creditMonths,
  setCreditMonths,
  secondaryMonths,
  setSecondaryMonths,
  setStartPrice,
  setStartPricePercentage,
  setDiscount,
  setDiscountPercentage,
  setSellPrice,
  setPriceForMonth,
  setMonth,
  setPriceForSquare,
  setSelectedDiscount,
  setStartPriceTopOrder,
  lastPayment,
  lastPaymentPercentage,
  handleChangeLastPayment,
  handleChangeLastPaymentPercentage,
  isCreditTable,
  isSubsidy,
}) {
  const { t } = useTranslation();
  return (
    <div>
      <div>
        <div className='flex w-full overflow-x-auto my-scroll py-3 mt-2 gap-4'>
          {homesData?.map((home) => (
            <div
              key={home?.id}
              className='images-wrapper min-w-[332px] !p-4 !shadow-none bg-[#F8F8F8] !rounded-[15px]'
            >
              <div className='w-[300px] h-[250px]'>
                {home?.plan &&
                  (home?.plan?.link ||
                    home?.plan?.link2d ||
                    home?.plan?.location) && (
                    <ImagesSwiper
                      imageURLs={[
                        home?.plan?.link,
                        home?.plan?.link2d,
                        home?.plan?.location,
                      ]}
                    />
                  )}
              </div>
              <div className='home-rooms-and-discount py-3'>
                <span className='home-data-divider mt-3'></span>
              </div>
              <div className='text-sm mt-1 [&>*]:my-1.5 [&>*>*:nth-child(2)]:text-sm [&>*>*:nth-child(2)]:font-bold'>
                <div className='flex justify-between items-center'>
                  <span>{t('common.fields.simpleName')}:</span>
                  <span>{home?.object?.name}</span>
                </div>
                <div className='flex justify-between items-center'>
                  <span>{t('shaxmatka.homeDetail.houseNumber')}:</span>
                  <span>№{home?.number}</span>
                </div>
                <div className='flex justify-between items-center'>
                  <span>{t('common.fields.rooms')}:</span>
                  <span>{home?.rooms}&nbsp;X</span>
                </div>
                <div className='flex justify-between items-center'>
                  <span>{t('shaxmatka.homeDetail.areaLive')}:</span>
                  <span>
                    {home?.square}&nbsp;
                    <Trans i18nKey='common.global.meter'>
                      m<sup>2</sup>
                    </Trans>
                  </span>
                </div>
                {Number(home?.terassa) == 0 ? (
                  ''
                ) : (
                  <div className='flex justify-between items-center'>
                    <span>{t('shaxmatka.homeDetail.areaTerrace')}:</span>
                    <span>
                      {Number(home?.terassa)}&nbsp;
                      <Trans i18nKey='common.global.meter'>
                        m<sup>2</sup>
                      </Trans>
                    </span>
                  </div>
                )}
                <div className='flex justify-between items-center'>
                  <span>
                    {Number(home?.square)}&nbsp;
                    <Trans i18nKey='common.global.meter'>
                      m<sup>2</sup>
                    </Trans>
                    :
                  </span>
                  <span className='text-green-500'>
                    {homesData?.length === 1 ? (
                      <EditableNumberField
                        initialValue={priceForSquare}
                        changeFn={handleChangePriceSquare}
                        decimalScale={1}
                      >
                        <NumericFormat
                          value={priceForSquare}
                          allowNegative={false}
                          displayType={'text'}
                          thousandSeparator={' '}
                          decimalScale={1}
                          className='price-text !text-[#16BA5C]'
                          suffix={currency == '1' ? ' $' : ' UZS'}
                        />
                      </EditableNumberField>
                    ) : (
                      <NumericFormat
                        value={priceForSquare}
                        allowNegative={false}
                        displayType={'text'}
                        thousandSeparator={' '}
                        decimalScale={1}
                        className='price-text !text-[#16BA5C]'
                        suffix={currency == '1' ? ' $' : ' UZS'}
                      />
                    )}
                  </span>
                </div>
                {Number(home?.terassa) == 0 ? (
                  ''
                ) : (
                  <div className='flex justify-between items-center'>
                    <span>
                      {Number(home?.terassa)}&nbsp;
                      <Trans i18nKey='common.global.meter'>
                        m<sup>2</sup>
                      </Trans>
                      :
                    </span>
                    <span className='text-green-500'>
                      {homesData?.length === 1 && false ? (
                        <EditableNumberField
                          initialValue={terassaPriceForSquare}
                          changeFn={handleChangeTerassaPriceSquare}
                          decimalScale={1}
                        >
                          <NumericFormat
                            value={terassaPriceForSquare}
                            allowNegative={false}
                            displayType={'text'}
                            thousandSeparator={' '}
                            decimalScale={1}
                            className='price-text !text-[#16BA5C]'
                            suffix={currency == '1' ? ' $' : ' UZS'}
                          />
                        </EditableNumberField>
                      ) : (
                        <NumericFormat
                          value={terassaPriceForSquare}
                          allowNegative={false}
                          displayType={'text'}
                          thousandSeparator={' '}
                          decimalScale={1}
                          className='price-text !text-[#16BA5C]'
                          suffix={currency == '1' ? ' $' : ' UZS'}
                        />
                      )}
                    </span>
                  </div>
                )}
                <div className='flex justify-between items-center'>
                  <span>{t('shaxmatka.homeDetail.price')}:</span>
                  <span className='text-green-500'>
                    {homesData?.length === 1 ? (
                      <EditableNumberField
                        initialValue={sellPrice}
                        changeFn={handleChangeSellPrice}
                        decimalScale={1}
                      >
                        <NumericFormat
                          value={sellPrice}
                          allowNegative={false}
                          displayType={'text'}
                          thousandSeparator={' '}
                          decimalScale={1}
                          className='price-text !text-[#16BA5C]'
                          suffix={currency == '1' ? ' $' : ' UZS'}
                        />
                      </EditableNumberField>
                    ) : (
                      <NumericFormat
                        value={home?.square * priceForSquare}
                        allowNegative={false}
                        displayType={'text'}
                        thousandSeparator={' '}
                        decimalScale={1}
                        className='price-text !text-[#16BA5C]'
                        suffix={currency == '1' ? ' $' : ' UZS'}
                      />
                    )}
                  </span>
                </div>
                <div className='flex justify-between items-center'>
                  <span>{t('shaxmatka.homeDetail.repairType')}:</span>
                  <div className='w-32'>
                    <Select
                      fullWidth
                      value={isrepaired || 0}
                      onChange={handleChange}
                    >
                      <MenuItem value={0}>
                        {t('common.typeList.repairType.notRepaired')}
                      </MenuItem>
                      <MenuItem value={1}>
                        {t('common.typeList.repairType.repaired')}
                      </MenuItem>
                    </Select>
                  </div>
                </div>
              </div>

              {discount > 0 && (
                <>
                  <div className='w-full relative'>
                    <span className='home-data-divider'></span>
                  </div>
                  <div className='discount-details-wrapper'>
                    <div>
                      <i className='bi bi-tag discount-icon' />{' '}
                      {discountPercentage}
                      {t('shaxmatka.moreHomeDetails.appliedDiscount')}
                    </div>
                    <div>
                      <i className='bi bi-patch-check discount-icon' />{' '}
                      <NumericFormat
                        value={
                          (home?.square *
                            (isrepaired == REPAIR_TYPE.REPAIRED.code
                              ? homeData?.repaired
                              : homeData?.norepaired) *
                            discountPercentage) /
                          100
                        }
                        allowNegative={false}
                        displayType={'text'}
                        thousandSeparator={' '}
                        decimalScale={1}
                        className='w-full text-right'
                        suffix={currency == '1' ? ' $' : ' UZS'}
                      />
                    </div>
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
      </div>
      <div className='mt-2'>
        <div className='grid grid-cols-[332px,1fr] gap-4'>
          <div className='!base-border !bg-[#F9F9F9] p-3'>
            <div className='mb-5'>{t('order.view.optionalStartPayment')}</div>
            <FormControlLabel
              control={<IOSSwitch />}
              labelPlacement='start'
              label={t('settings.discounts.addDiscountModal.types.type1')}
              sx={{
                justifyContent: 'space-between',
                marginLeft: '0',
                width: '100%',
                marginBottom: '8px',
              }}
              checked={startPriceTopOrder}
              onChange={({ target }) =>
                handleChangeStartPriceOrder(target?.checked)
              }
            />
            <div className='grid grid-cols-2 gap-2 my-2.5'>
              <SimpleNumberField
                delay={0}
                duration={0}
                value={startPrice}
                setValue={handleChangeStartPrice}
                label={t('common.fields.startPrice')}
                name='startPrice'
                className='!bg-white'
                size='small'
              />
              <SimpleNumberField
                delay={0}
                duration={0}
                value={startPricePercentage}
                setValue={handleChangeStartPricePercent}
                label={t('common.fields.startPricePercentage')}
                name='startPrice'
                className='!bg-white'
                size='small'
              />
            </div>
            <div className='w-full my-2.5'>
              <SimpleNumberField
                delay={0}
                duration={0}
                value={priceForMonth}
                setValue={handleChangePriceForMonth}
                label={t('shaxmatka.homeDetail.monthlyPay')}
                name='startPrice'
                className='!bg-white'
                size='small'
              />
            </div>
            <div className='grid grid-cols-2 gap-2 my-2.5'>
              <SimpleNumberField
                delay={0}
                duration={0}
                value={lastPayment}
                setValue={handleChangeLastPayment}
                label={t('common.fields.lastPayment')}
                name='startPrice'
                className='!bg-white'
                size='small'
              />
              <SimpleNumberField
                delay={0}
                duration={0}
                value={lastPaymentPercentage}
                setValue={handleChangeLastPaymentPercentage}
                label={t('common.fields.lastPaymentPercentage')}
                name='startPrice'
                className='!bg-white'
                size='small'
              />
            </div>

            <div className='mb-5'>
              <SimpleNumberField
                delay={0}
                duration={0}
                value={month}
                setValue={handleChangeMonth}
                label={t('shaxmatka.moreHomeDetails.month')}
                className='!bg-white !mt-3.5'
                placeholder={t('shaxmatka.moreHomeDetails.type')}
                name='monthValue'
                size='small'
              />
            </div>
            <div>
              {homesData?.length === 1 && (
                <div className='flex items-center w-full'>
                  <DiscountPanel
                    setApplyDiscount={setApplyDiscount}
                    applyDiscount={applyDiscount}
                    home_id={homeData?.id}
                    formik={formik}
                  />
                </div>
              )}
            </div>
          </div>

          <div>
            <div className='payment-details-wrapper !mt-0 mb-1 !pt-0'>
              {/* <div className='mb-2'>{t('order.view.paymentContracts')}</div> */}
              <Grid
                container
                spacing={1}
                rowSpacing={1}
                columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
              >
                <Grid item={true} md={3} sm={4} xs={12}>
                  <div className='payment-item-wrapper !shadow-none !base-border'>
                    <div className='w-[35px] h-[35px] flex items-center justify-center mb-2.5 rounded-lg bg-[#F0F0FA]'>
                      <i className='bi bi-currency-dollar payment-item-icon !text-[#7947F8]' />
                    </div>
                    <div>
                      <div className='payment-item-label'>
                        {t('payment.add.contract.totalSum')}
                      </div>
                      <NumericFormat
                        value={fullPrice}
                        allowNegative={false}
                        displayType={'text'}
                        thousandSeparator={' '}
                        decimalScale={3}
                        className='w-full text-right'
                        suffix={currency == '1' ? ' $' : ' UZS'}
                      />
                    </div>
                  </div>
                </Grid>
                <Grid item={true} md={3} sm={4} xs={12}>
                  <div className='payment-item-wrapper !shadow-none !base-border'>
                    <div className='w-[35px] h-[35px] flex items-center justify-center mb-2.5 rounded-lg bg-[#F0F0FA]'>
                      <i className='bi bi-percent payment-item-icon !text-[#7947F8]' />
                    </div>
                    <div>
                      <div className='payment-item-label'>
                        {t('shaxmatka.moreHomeDetails.discount')}
                      </div>
                      <EditableNumberField
                        initialValue={discount}
                        changeFn={handleChangeDiscount}
                        decimalScale={1}
                      >
                        <NumericFormat
                          value={discount || '0'}
                          allowNegative={false}
                          displayType={'text'}
                          thousandSeparator={' '}
                          decimalScale={3}
                          size={'small'}
                          className='w-full text-right'
                          suffix={currency == '1' ? ' $' : ' UZS'}
                        />
                      </EditableNumberField>
                      &nbsp;(
                      <EditableNumberField
                        initialValue={discountPercentage}
                        changeFn={handleChangeDiscountPercentage}
                        decimalScale={1}
                      >
                        <NumericFormat
                          value={discountPercentage || 0}
                          allowNegative={false}
                          displayType={'text'}
                          thousandSeparator={' '}
                          decimalScale={3}
                          size={'small'}
                          className='w-full text-right'
                          suffix={' %'}
                        />
                      </EditableNumberField>
                      )
                    </div>
                  </div>
                </Grid>
                <Grid item={true} md={3} sm={4} xs={12}>
                  <div className='payment-item-wrapper !shadow-none !base-border'>
                    <div className='w-[35px] h-[35px] flex items-center justify-center mb-2.5 rounded-lg bg-[#F0F0FA]'>
                      <i className='bi bi-wallet2 payment-item-icon !text-[#7947F8]' />
                    </div>
                    <div>
                      <div className='payment-item-label'>
                        {t('shaxmatka.moreHomeDetails.startPrice')}
                      </div>
                      <NumericFormat
                        value={startPrice}
                        allowNegative={false}
                        displayType={'text'}
                        thousandSeparator={' '}
                        decimalScale={3}
                        className='w-full text-right'
                        suffix={currency == '1' ? ' $' : ' UZS'}
                      />
                      &nbsp;({startPricePercentage} %)
                    </div>
                  </div>
                </Grid>
                <Grid item={true} md={3} sm={4} xs={12}>
                  <div className='payment-item-wrapper !shadow-none !base-border'>
                    <div className='w-[35px] h-[35px] flex items-center justify-center mb-2.5 rounded-lg bg-[#F0F0FA]'>
                      <i className='bi bi-calendar payment-item-icon !text-[#7947F8]' />
                    </div>
                    <div>
                      <div className='payment-item-label'>
                        {t('shaxmatka.moreHomeDetails.monthlyPrice')}(
                        {t('shaxmatka.moreHomeDetails.monthValue', {
                          value: month,
                        })}
                        )
                      </div>
                      <NumericFormat
                        value={priceForMonth}
                        allowNegative={false}
                        displayType={'text'}
                        thousandSeparator={' '}
                        decimalScale={3}
                        className='w-full text-right'
                        suffix={currency == '1' ? ' $' : ' UZS'}
                      />
                    </div>
                  </div>
                </Grid>
              </Grid>
              <Grid
                container
                spacing={1}
                rowSpacing={1}
                className='!mt-1'
                alignItems={'center'}
                columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
              >
                <Grid item={true} md={3} sm={4} xs={12}>
                  <FormControlLabel
                    control={<IOSSwitch />}
                    labelPlacement='start'
                    label={t('common.table.creditCalc')}
                    sx={{
                      justifyContent: 'space-between',
                      marginLeft: '0',
                      width: '100%',
                      marginBottom: '8px',
                    }}
                    checked={isEnableCalc}
                    onChange={({ target }) => {
                      setIsEnableCalc(target?.checked);
                    }}
                  />
                </Grid>
                {isEnableCalc && (
                  <>
                    <Grid item={true} md={2} sm={4} xs={12}>
                      <SimpleNumberField
                        delay={0}
                        disabled={!isEnableCalc}
                        duration={0}
                        value={percent}
                        setValue={(val) => setPercent(val || 0)}
                        label={t('common.fields.percent')}
                        name='startPrice'
                        className='!bg-white'
                        size='small'
                      />
                    </Grid>
                    <Grid item={true} md={2} sm={4} xs={12}>
                      <SimpleNumberField
                        delay={0}
                        disabled={!isEnableCalc}
                        duration={0}
                        value={secondaryPercent}
                        setValue={(val) => setSecondaryPercentOverride(val || 0)}
                        label={t('common.fields.secondaryRate')}
                        name='secondaryPercent'
                        className='!bg-white'
                        size='small'
                      />
                    </Grid>
                    <Grid item={true} md={2} sm={4} xs={12}>
                      <SimpleNumberField
                        delay={0}
                        disabled={!isEnableCalc}
                        duration={0}
                        value={creditMonths}
                        setValue={(val) => setCreditMonths(val || 0)}
                        label={t('common.fields.primaryMonthsShort')}
                        name='creditMonths'
                        className='!bg-white'
                        size='small'
                      />
                    </Grid>
                    {/* Ikkilamchi kredit ko'pincha qisqaroq muddatga beriladi */}
                    <Grid item={true} md={2} sm={4} xs={12}>
                      <SimpleNumberField
                        delay={0}
                        disabled={!isEnableCalc}
                        duration={0}
                        value={secondaryMonths}
                        setValue={(val) => setSecondaryMonths(val || 0)}
                        label={t('common.fields.secondaryMonthsShort')}
                        name='secondaryMonths'
                        className='!bg-white'
                        size='small'
                      />
                    </Grid>
                    <Grid item={true} md={3} sm={4} xs={12}>
                      <div className='bg-gray-50 p-0.5 px-2 rounded-md grow'>
                        <div className='text-xs'>
                          {t('payment.add.contract.totalSum')}
                        </div>
                        <span className='text-green-600 text-sm'>
                          <CurrencyFormat
                            value={calculations?.totalPayment}
                            suffix=''
                          />
                        </span>
                      </div>
                    </Grid>
                    <Grid item={true} md={3} sm={4} xs={12}>
                      <div className='bg-gray-50  p-0.5 px-2 rounded-md grow'>
                        <div className='text-xs'>
                          {t('shaxmatka.homeDetail.monthlyPay')}
                        </div>
                        <span className='text-green-600 text-sm'>
                          <CurrencyFormat
                            value={calculations?.monthlyPayment}
                            decimalScale={2}
                            suffix=''
                          />
                        </span>
                      </div>
                    </Grid>
                  </>
                )}
              </Grid>
            </div>
            <DiscountTable
              applyDiscount={applyDiscount}
              startPrice={startPrice}
              setStartPrice={setStartPrice}
              currency={currency}
              startPricePercentage={startPricePercentage}
              setStartPricePercentage={setStartPricePercentage}
              discount={discount}
              setDiscount={setDiscount}
              discountPercentage={discountPercentage}
              setDiscountPercentage={setDiscountPercentage}
              sellPrice={sellPrice}
              setSellPrice={setSellPrice}
              priceForMonth={priceForMonth}
              setPriceForMonth={setPriceForMonth}
              month={month}
              setMonth={setMonth}
              discountId={formik.values?.discountId || null}
              fullPrice={fullPrice}
              setPriceForSquare={setPriceForSquare}
              square={homeData?.square}
              selectedDiscount={selectedDiscount}
              setSelectedDiscount={setSelectedDiscount}
              defaultStartPrice={homeData?.start}
              setStartPriceTopOrder={setStartPriceTopOrder}
              lastPayment={lastPayment}
              isCreditTable={isCreditTable}
              isSubsidy={isSubsidy}
              calculations={calculations}
              subsidyCals={subsidyCals}
              splitCals={splitCals}
            />
          </div>
        </div>
      </div>
    </div>
  );
});

const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName='.Mui-focusVisible' disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: '#65C466',
        opacity: 1,
        border: 0,
        ...theme.applyStyles('dark', {
          backgroundColor: '#2ECA45',
        }),
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: theme.palette.grey[100],
      ...theme.applyStyles('dark', {
        color: theme.palette.grey[600],
      }),
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: 0.7,
      ...theme.applyStyles('dark', {
        opacity: 0.3,
      }),
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: '#E9E9EA',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
    ...theme.applyStyles('dark', {
      backgroundColor: '#39393D',
    }),
  },
}));
